<template>
  <b-container class="page-container">
    <Breadcrumbs currentpage="Wachtwoord vergeten" />
    <h1>{{ $t('forgot-your-password') }}?</h1>
    <p>
      {{ $t('fill-in-email-restore-password') }}
    </p>

    <b-alert v-if="resetLinkSend" show variant="warning">
      {{ $t('receive-email-to-reset-password') }}
    </b-alert>
    <b-row>
      <b-col sm="12" class="mb-3"></b-col>

      <b-col sm="12" md="6" lg="4">
        <b-card>
          <b-form @submit.prevent="resetPasswordSubmit">
            <b-form-group
              id="input-group-1"
              label="E-mailadres"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="form.email"
                :disabled="resetLinkSend"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
            <b-row>
              <b-col cols="12">
                <b-button
                  :disabled="resetLinkSend"
                  class="mb-2"
                  type="submit"
                  variant="primary"
                  >{{ $t('request-password') }}
                  <icon-spinner v-if="requesting" class="fa-spin" />
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { requestPasswordReset } from '@/services/AuthorizationService'
import Breadcrumbs from '@/components/header/BreadCrumbs'
import IconSpinner from '@/components/icons/IconSpinner'
export default {
  components: {
    IconSpinner,
    Breadcrumbs
  },
  data() {
    return {
      form: {
        email: ''
      },
      resetLinkSend: false,
      requesting: false
    }
  },
  computed: {
    frontendURL: function() {
      return process.env.VUE_FRONTEND_URL
    }
  },
  methods: {
    async resetPasswordSubmit() {
      this.requesting = true

      const result = await requestPasswordReset({
        email: this.form.email
      })

      if (result.data != null) {
        this.resetPasswordSubmit = true
      }

      this.resetLinkSend = true
      this.requesting = false
    }
  }
}
</script>
<style scoped lang="scss">
a.btn {
  text-decoration: none;
}
</style>
